// Public allowlisted IDs only. These describe a selection, never authorization.
export const COMPANY_IDS=['bmi','hudson'];
export function canonicalCompanyIds(ids){return Array.isArray(ids)?[...new Set(ids)].filter(id=>COMPANY_IDS.includes(id)).sort():[];}
export function validCompanyIds(ids){return Array.isArray(ids)&&ids.every(id=>COMPANY_IDS.includes(id));}
export function financialCompanyScope(path){
 const params=new URLSearchParams(path?.split('?')[1]||'');
 if(!params.has('companies'))return 'hudson';
 if(params.getAll('companies').length!==1)return null;
 const ids=params.get('companies').split(',');
 return ids.length&&ids.every(id=>COMPANY_IDS.includes(id))?canonicalCompanyIds(ids).join(','):null;
}
// Reserved request contract: not invoked for BMI until its backend is verified.
export function withFinancialCompanies(path,ids){
 if(!path||!validCompanyIds(ids)||!ids.length)return null;
 const companies=canonicalCompanyIds(ids),[route,query='']=path.split('?'),params=new URLSearchParams(query);
 params.delete('companies');if(companies.join(',')!=='hudson')params.set('companies',companies.join(','));
 return route+'?'+params.toString();
}
export const companyScopesOverlap=(a,b)=>typeof a==='string'&&typeof b==='string'&&a.split(',').some(id=>b.split(',').includes(id));
